export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-20"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-secondary-50/40"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/20 blur-3xl"></div>
      <div className="absolute bottom-10 left-0 w-[400px] h-[400px] rounded-full bg-accent-50/25 blur-3xl"></div>

      <div className="relative w-full mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-[13px] font-semibold mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              每日更新 200+ 话 · 海量漫画持续上新
            </div>

            <h1 className="text-[28px] md:text-[40px] lg:text-[48px] font-heading font-extrabold text-foreground-950 leading-tight tracking-tight mb-4">
              新新漫画
              <span className="block text-[20px] md:text-[24px] lg:text-[28px] font-semibold text-foreground-600 mt-1">
                韩漫日漫国漫一站式分类阅读平台
              </span>
            </h1>

            <p className="text-[15px] md:text-[16px] text-foreground-500 font-medium mb-3">
              热门漫画类型分类推荐，好看漫画一次收藏
            </p>

            <p className="text-[14px] leading-relaxed text-foreground-600 max-w-[560px] mx-auto lg:mx-0 mb-6">
              新新漫画汇聚全网优质韩漫、日漫与国漫资源，按类型精细化分类，
              从纯爱到热血、从悬疑到搞笑、从古风到都市，让你用最短时间找到最对味的作品。
              每日追踪更新进度，热门榜单实时呈现，一次收藏永久回看，打造属于你的专属漫画书架。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-extrabold text-primary-500">3000+</span>
                <span className="text-[13px] text-foreground-500">部收录作品</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-extrabold text-accent-500">200+</span>
                <span className="text-[13px] text-foreground-500">话 / 日更新量</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-extrabold text-secondary-500">全类型</span>
                <span className="text-[13px] text-foreground-500">精细化分类</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#topics');
                }}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-bold text-[15px] hover:bg-primary-600 transition-colors text-center cursor-pointer"
              >
                开始探索热门分类
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#ranking');
                }}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-primary-300 text-primary-600 font-bold text-[15px] hover:bg-primary-50 transition-colors text-center cursor-pointer"
              >
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-tr from-primary-200/40 via-accent-100/30 to-secondary-100/40 rounded-3xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20manga%20comic%20panels%20floating%20in%20dynamic%20composition%2C%20warm%20orange%20and%20coral%20accents%20on%20cream%20background%2C%20Japanese%20and%20Chinese%20manga%20style%20line%20art%20with%20speech%20bubbles%2C%20action%20lines%2C%20clean%20modern%20aesthetic%2C%20editorial%20design%2C%20soft%20gradients%2C%20harmonious%20warm%20tone%20illustration&width=1000&height=1200&seq=hero-manga-visual-01&orientation=portrait"
                alt="新新漫画 — 韩漫日漫国漫一站式阅读平台视觉插图"
                className="relative w-full h-auto max-h-[500px] object-contain rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}